<ng-container [ngSwitch]="!!expandableTitle">
    <div [ngClass]="{'b-b b-col-42 p-l-3 p-r-3 p-t-6 p-b-5' : expandableIcon === 'plus' && addBorder}">
        <div class="flex flex-justify-between cursor-pointer col-1"
             [ngClass]="{'p-b-3 p-t p-t-1-s' : expandableIcon === 'chevron'}"
             [zippyToggle]="zippyId">

            <!-- title -->
            <div class="flex-grow w-12 flex flex-middle flex-justify-between pos-relative">
                <label *ngSwitchCase="true"
                       [zippyName]="zippyId"
                       [zippyClass]="expandableIcon === 'chevron' ? 'col-12' : ''">{{expandableTitle}}</label>
                <ng-container *ngSwitchCase="false">
                    <ng-container *ngTemplateOutlet="expandableTitleTpl"></ng-container>
                </ng-container>
            </div>

            <!-- icon -->
            <ng-container *ngIf="expandableIcon === 'chevron'">
                <i class="icon-chevron expandable-icon flex flex-middle fs-9"
                   [zippyClass]="'rotate-90 col-12'"
                   [zippyName]="zippyId"></i>
            </ng-container>

            <ng-container *ngIf="expandableIcon === 'plus'">
                <i class="icon-plus fs-7"
                   [zippyClass]="'icon-minus !icon-plus'"
                   [zippyName]="zippyId"></i>
            </ng-container>
        </div>

        <!-- body -->
        <div [zippyHideUp]="zippyId"
             [zippyState]="openAtStart">
            <ng-container *ngSwitchCase="true">
                <ng-container *ngTemplateOutlet="expandableContentTpl"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="false">
                <ng-container *ngTemplateOutlet="expandableBodyTpl"></ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template #expandableTitleTpl>
    <ng-content select="[expandableTitle]"></ng-content>
</ng-template>
<ng-template #expandableBodyTpl>
    <ng-content select="[expandableBody]"></ng-content>
</ng-template>
<ng-template #expandableContentTpl>
    <ng-content></ng-content>
</ng-template>
